<div class="container-fluid" style="background-color:#3a3a3a;height:100%;min-height:calc(100vh - 184px);">
    <div class="row m-0">
        <div class="col-12 col-md-4 offset-md-4 mb-3 px-0 bg-animated">
            <router-outlet></router-outlet>            
        </div>
    </div>
</div>